export default __webpack_public_path__ + "static/media/user-pin.759f7e01.svg";